import React, { useCallback } from 'react'
import { FlatList } from 'react-native'

import { zodResolver } from '@hookform/resolvers/zod'
import useAddCustomerStore from '@zet/customer/src/store/addCustomer'
import { Button, colors, Stack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import { KeyBoardWrapper } from '@zet/utils'
import moment from 'moment'
import { useUnsafeVariable } from 'nativewind'
import { useForm } from 'react-hook-form'

import { HeaderDetailsSection } from '../../components'
import FormController from '../../form/FormController'
import { useAddCustomerState } from '../../hooks/useAddCustomer'
import useGetAgentDetailsAndTheme from '../../hooks/useGetAgentDetailsAndTheme'
import { panDetailsValidationScheme } from '../../utils/validationSchemas'
import { panDetailsFormFields } from './formFields'

export const QuickJourneyPanDetails = () => {
  useGetAgentDetailsAndTheme()
  const [colorPrimary100] = useUnsafeVariable('--color-primary-100')

  const {
    control,
    formState: { isValid },
    getValues,
  } = useForm({
    mode: 'onTouched',
    resolver: zodResolver(panDetailsValidationScheme),
  })
  const { customerId } = useAddCustomerStore()
  const { mutate, isLoading } = useAddCustomerState()

  const renderItem = useCallback(({ item }) => {
    return <FormController control={control} ocField={item} />
  }, [])

  const handleSubmit = () => {
    const { panNumber, dob } = getValues()
    const urlParams = new URLSearchParams(window.location.search)
    const hash = urlParams.get('hashNew')
    const custId = urlParams.get('customerId')
    const requestBodyData = {
      customerId: custId || customerId,
      panNo: panNumber,
      dob: moment(dob).format('YYYY-MM-DD'),
      screenName: 'SHOWN_QUICK_PAN_SCREEN',
      hash: hash as string,
    }
    mutate(requestBodyData)
  }

  return (
    <KeyBoardWrapper
      BottomSheet={
        <Stack className="border-t-grays-30 border-t px-2 py-2">
          <Button
            size={'lg'}
            className="w-full"
            disabled={!isValid}
            style={{
              backgroundColor: isValid ? colorPrimary100 : colors.grays[50],
            }}
            onPress={handleSubmit}
            loading={isLoading}
          >
            {i18n.t('bottomView.continue')}
          </Button>
        </Stack>
      }
    >
      <Stack className="flex-1 bg-white px-3">
        <FlatList
          showsVerticalScrollIndicator={false}
          data={panDetailsFormFields}
          ListHeaderComponent={
            <HeaderDetailsSection
              subTitle="Add PAN details to check credit score and get card recommendations"
              title="Enter Your PAN Details"
            />
          }
          renderItem={renderItem}
        />
      </Stack>
    </KeyBoardWrapper>
  )
}
